import script from "./FormCheckboxGroupField.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormCheckboxGroupField.vue?vue&type=script&lang=ts&setup=true"

import "./FormCheckboxGroupField.vue?vue&type=style&index=0&id=132c6bf4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-132c6bf4"]])

export default __exports__